import { faEyeSlash } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Box, Image, StatusBadge } from '@domain-group/suit-theme'

import { UseImagePayload } from '@hooks/useImage'

interface ListItemImageProps {
  hasPublicImages: boolean,
  imagePayload: UseImagePayload,
  index: number,
}

const ListItemImage = (props: ListItemImageProps) => {
  const { hasPublicImages, imagePayload, index } = props

  const {
    image: { thumb_url, private: isPrivate },
  } = imagePayload

  return (
    <Image
      borderRadius={5}
      boxProps={{
        border: '1px solid', borderColor: 'lineColor', height: '60px', marginRight: 'large', width: '90px',
      }}
      forwardProps={{ backgroundColor: 'whiteGrey' }}
      url={thumb_url}
    >
      <Box
        backgroundColor={isPrivate && hasPublicImages ? 'rgba(255, 255, 255, 0.7)' : null}
        height="100%"
        position="relative"
      >
        {isPrivate && (
          <StatusBadge
            boxProps={{
              padding: 'small',
              position: 'absolute',
              top: 'small',
              right: 'small',
              width: 'auto',
            }}
            color="grey"
            icon={<FontAwesomeIcon icon={faEyeSlash} />}
          />
        )}

        <Box
          alignItems="center"
          backgroundColor="bodyFontColor"
          borderRadius="100%"
          color="white"
          fontSize="xsmall"
          height="20px"
          justifyContent="center"
          left="small"
          position="absolute"
          top="small"
          width="20px"
        >
          {index + 1}
        </Box>
      </Box>
    </Image>
  )
}

export default ListItemImage
